import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-rh-payers',
  templateUrl: './rh-payers.component.html',
  styleUrls: ['./rh-payers.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})
export class RhPayersComponent implements OnInit {

  columnsToDisplay1 = ['InsuranceName', 'InsuranceCode', 'ClaimType', 'PayerId ', 'CPID', 'EligId', ' PortalEligId', 'ClaimStatusId', 'EnrolIndicator', 'Isactive ', ' Address'];
  headercolumnsToDisplay1 = ['Insurance Name ', 'Insurance Code ', 'Claim Type', 'Payer Id  ', 'CPID ', 'Elig.Id', 'Portal Elig.Id ', ' Claim Status Id ', 'Enrol Indicator', 'Isactive ', 'Address '];
  displayedColumns: string[] = ['planname', 'claimtype', 'action'];
  show: boolean;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }

  rhpayersform: FormGroup;
  submitted = false;



  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.rhpayersform = this.formBuilder.group({

      insname: ['',],
      enrollment: ['',],
      inscode: ['',],
      phn: ['',],
      email: ['',],
      payerclass: ['',],
      payertype: ['',],
      url: ['',],
      adrsline1: ['',],
      adrsline2: ['',],
      city: ['',],
      state: ['',],
      zip: ['',],
      fax: ['',],
      formtype: ['',],
      payerid: ['',],
      eligid: ['',],
      portalelig: ['',],
      claimid: ['',],
      planname: ['',],
      claimtype: ['',],
      insnames: ['',],
      enrollmentind: ['',],
      inscodes: ['',],
      phone: ['',],
      emails: ['',],
      payerclasss: ['',],
      payertypes: ['',],
      urls: ['',],
      adrslinee1: ['',],
      adrslinee2: ['',],
      cityy: ['',],
      statee: ['',],
      zipp: ['',],
      faxx: ['',],
      formtypes: ['',],
      payerids: ['',],
      eligidd: ['',],
      portaleligid: ['',],
      claimids: ['',],
      plannames: ['',],
      claimtypes: ['',],


    });
  }
  get f() { return this.rhpayersform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.rhpayersform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.rhpayersform.value))
  }
}





